import React, { Fragment, useEffect, useState } from "react";
import "./LowStock.css";
import {
  Dialog,
  DialogContent,
  Grid,
  Typography,
  DialogTitle,
  DialogActions,
  Button,
  TextField,
} from "@mui/material";

const LowStock = (props) => {
  const {
    data,
    action,
    cQty,
    unitType,
    display = false,
    add,
    addCase,
    substract,
    substractCase,
    handleAmountChange,
    resetLowStock,
    handleDisplaySubs,
  } = props;

  const [openLowStockDialog, setOpenLowStockDialog] = useState(false);
  const [qty, setQty] = useState(0);

  const handleCloseLowStockDialog = () => {
    resetLowStock();
    setOpenLowStockDialog(false);
  };

  const handleQtyChange = (e) => {
    const { value } = e.target;

    const amount = value === "" ? 0 : value;

    setQty(amount);
  };

  const handleAction = () => {
    switch (action) {
      case "amount":
        const ev = { target: { name: unitType, value: qty } };
        handleAmountChange(ev);
        setQty(0);
        break;
      case "add":
        add();
        break;
      case "substract":
        substract();
        break;
      case "addCase":
        addCase();
        break;
      case "substractCase":
        substractCase();
        break;
      default:
    }
    handleCloseLowStockDialog();
  };

  useEffect(() => {
    if (display) {
      setOpenLowStockDialog(true);
    }
  }, [display]);

  useEffect(() => {
    if (action === "amount") {
      setQty(cQty);
    }
  }, [action, cQty]);

  return (
    <>
      <Dialog onClose={handleCloseLowStockDialog} open={openLowStockDialog}>
        <DialogTitle>Item with low stock</DialogTitle>
        <DialogContent>
          <Grid container spacing={1}>
            <Grid item xs={12}>
              <Typography variant="subtitle1">
                <b>{`${data.name}`}</b>
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography>
                <b>Note: </b> If you <b>continue</b> this item might not be
                included in your final shipment due to low or no stock.
              </Typography>
            </Grid>
            <Grid item xs={12}></Grid>
            {action === "amount" ? (
              <>
                <Grid item xs={true} textAlign="right">
                  <b>{`Please confirm the total amount of ${
                    unitType === "unit_in_cart" ? "units" : "cases"
                  }:`}</b>
                </Grid>
                <Grid item xs={2}>
                  <TextField
                    fullWidth
                    type="number"
                    size="small"
                    variant="standard"
                    name="qty"
                    value={qty}
                    onChange={handleQtyChange}
                    inputProps={{ style: { textAlign: "center" } }}
                  />
                </Grid>
              </>
            ) : (
              <></>
            )}
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button
            color="error"
            variant="contained"
            onClick={handleCloseLowStockDialog}
          >
            Cancel
          </Button>
          {data.acceptable_substitutions &&
          data.acceptable_substitutions.length ? (
            <Button
              color="info"
              variant="contained"
              onClick={handleDisplaySubs}
            >
              Substitutions
            </Button>
          ) : (
            <></>
          )}
          <Button color="success" variant="contained" onClick={handleAction}>
            Continue
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default LowStock;
